import FarmsView from './views/FarmsView.vue'
import FarmView from './views/FarmView.vue'
import GrazingView from './views/GrazingView.vue'

export default [
  { path: '/grazing/farms', name: 'grazing/farms', component: FarmsView, meta: { title: 'Farms', layout: 'narrow', role: 'Grazing' } },

  { path: '/grazing/farm/:id', name: 'grazing/farm/by-id', navHide: true, component: FarmView, meta: { title: 'Farm', layout: 'fluid', role: 'Grazing' }, props: true },

  { path: '/grazing/single-grazing/:farmId/:grazingId', name: 'grazing/single-grazing', navHide: true, component: GrazingView, meta: { title: 'Grazing', layout: 'fluid', role: 'Grazing' }, props: true },
]



// WEBPACK FOOTER //
// ./src/grazing/routes.js